import { Component, Input, Output, EventEmitter } from '@angular/core';
import * as _ from 'lodash';

import { SearchResultsComponent } from 'shared/search/search-results/search-results.component';


@Component({
  moduleId: module.id,
  selector: 'export-manager-search-results',
  templateUrl: 'export-manager-search-results.component.html',
  styleUrls: ['export-manager-search-results.component.scss']
})
export class ExportManagerSearchResultsComponent extends SearchResultsComponent {
  @Output() downloadClick: EventEmitter<any> = new EventEmitter<any>();
  @Output() receiversClick: EventEmitter<any> = new EventEmitter<any>();

  /*******************************************
   * COMPONENT HANDLERS
   *******************************************/

  onCheckboxChange(row: any) {
    this.changeCheckbox.emit(row);
  }

  onCheckboxClick(row: any) {
    this.checkboxClick.emit(row);
  }

  onDetailsBtnClick(row: any) {
    this.detailsBtnClick.emit(row);
  }

  onDownloadClick(row: any) {
    this.downloadClick.emit(row);
  }

  onReceiversClick(receivers: any[]) {
    this.receiversClick.emit(receivers);
  }

}
